export const SET_LAYER_VIS = 'SET_LAYER_VIS';
export const SET_LAYER_OPACITY = 'SET_LAYER_OPACITY';

export const setLayerVis = data => {
  return { type: SET_LAYER_VIS, payload: data };
};

export const setLayerOpacity = data => {
  return { type: SET_LAYER_OPACITY, payload: data };
};
